import moment from 'moment';
import React from 'react';
import './HomePage.css';
import circleLogo from './../../img/circle-logo@2x.png';


const NORMAL_URL = 'https://circledna.com/downloads';
const PROMO_URL = 'https://circledna.com/vitalupgrade';

const PROMO_END_DATE = moment.utc('2020-09-14 02:29:59');

export default class HomePage extends React.PureComponent {
  render() {
    const redirectUrl = moment.utc().isBefore(PROMO_END_DATE)
      ? PROMO_URL
      : NORMAL_URL;
    window.location.href = redirectUrl;
    return <div className="HomePage">
      <div style={{ textAlign: 'center' }}>
        <img src={circleLogo} alt="Circle DNA" />
      </div>
      <div style={{ marginTop: '3em', textAlign: 'center' }}>
        Please download the Circle App from <a href={redirectUrl}>circledna.com/downloads</a> to view your reports.
      </div>
    </div>;
  }
}
